module.exports = __webpack_public_path__ + "static/media/ad-lmi-college.c4e745d1.jpg";